// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { Apple as AppleIcon } from '@zocdoc-frontend-common/assets-icons';

import BaseSocialLoginButton, { IconContainer } from './BaseSocialLoginButton';

export default function AppleLoginButton({
    message = 'Continue with Apple',
    ...props
}) {
    return <StyledLoginButton icon={AppleIcon} message={message} {...props} />;
}

const StyledLoginButton = styled(BaseSocialLoginButton)`
    background-color: black;

    ${IconContainer} {
        font-size: 28px;
    }

    &:hover,
    &:active {
        background-color: grey;
    }
`;
